import { Paragraph } from '@zillow/constellation-10';

import { wizardParagraphStyles } from '../../../../../styles/wizard';

import FinancialExpectationsFormField from '../../../../PostingPath/FinancialExpectationsFormField';

export const FinancialExpectationsIntroAndFields = () => {
  return (
    <div data-testid="FinancialExpectationsIntroAndFields">
      <Paragraph data-testid="FinancialExpectationsIntroAndFields-Intro" css={wizardParagraphStyles}>
        We display these criteria on your listing and use them to help you review prospective renters, so you can
        quickly see who&apos;s a good fit for your property.
      </Paragraph>

      <FinancialExpectationsFormField />
    </div>
  );
};
